module.exports = __webpack_public_path__ + "img/image_2.212b3fc8.gif";